// Revendo: Filial-Filter-Dropdown (snippets/verfugbar-filter.liquid). Ursprünglich
// Theme-App-Extension der App „Store Filter“ (Aiconomy), jetzt Theme-Asset.
if (!window.verfugbarFilterLoaded) {
  window.verfugbarFilterLoaded = true;

  // "Postversand" ist das Pseudo-Filial-Metaobject der App. Seine ID ist pro
  // Store verschieden (Staging ≠ Production). Liquid findet es über den Handle
  // und gibt die ID aus (snippets/revendo-mobile-sortbar.liquid); das deutsche
  // Label bleibt Rückfall, EN/FR/IT übersetzen es ("Expédition postale" …).
  const POSTVERSAND_LABEL = "postversand";
  const postversandId = () =>
    document.querySelector("[data-revendo-postversand]")?.dataset
      .revendoPostversand;

  // Nur die beiden Zustandsfacetten benötigen zusätzlich „Auf Lager“.
  const AVAILABILITY_COUPLED_FILTERS = [
    "filter.v.t.shopify.cosmetic-condition",
    "filter.v.option.akkuzustand",
  ];
  const needsAvailabilityFilter = (filterName) =>
    AVAILABILITY_COUPLED_FILTERS.includes(filterName);
  // Liquid setzt die Auf-Lager-Option auf disabled, wenn value.count == 0.
  // Auf einer komplett ausverkauften Collection wäre das Auto-Filter ein leeres
  // Grid – nur aktivieren, wenn mindestens eine Auf-Lager-Checkbox klickbar ist.
  const inStockAvailabilitySelector =
    'input[name="filter.v.availability"][type="checkbox"][value="1"]';
  const hasInStockProducts = (root = document) =>
    Array.from(root.querySelectorAll(inStockAvailabilitySelector)).some(
      (cb) => !cb.disabled,
    );
  const storeFilterName = "filter.p.m.custom.available_in_stores";
  const storeInputSelector = `input[name="${storeFilterName}"]`;
  const isPostversandInput = (input) => {
    if (!input) return false;
    const id = postversandId();
    if (id) return input.value === id;
    const label =
      input
        .closest(".verfugbar-dropdown-item")
        ?.querySelector(".verfugbar-option-text") ||
      input.labels?.[0]?.querySelector(".facet-checkbox__text-label");
    return (
      Boolean(label) &&
      label.textContent.trim().toLowerCase() === POSTVERSAND_LABEL
    );
  };
  const dropdownInputSelector = ".verfugbar-filter-checkbox";
  const isMobileDropdown = (dropdown) =>
    dropdown.querySelector(dropdownInputSelector)?.dataset.isMobile === "true";
  const isFilterForm = (form) =>
    ["FacetFiltersForm", "FacetFiltersFormMobile"].includes(form?.id);
  const isFacetForm = (form) =>
    isFilterForm(form) ||
    ["FacetSortForm", "FacetSortDrawerForm"].includes(form?.id);
  const hiddenStoreInputs = (form, name = storeFilterName) =>
    form.querySelectorAll(`input[name="${name}"][type="hidden"]`);

  function setSelectedText(dropdown, input, labelSource = dropdown) {
    const label = input
      ?.closest(".verfugbar-dropdown-item")
      ?.querySelector(".verfugbar-option-text");
    const text = dropdown.querySelector(".verfugbar-selected-text");
    if (!label || !text) return;
    const title =
      labelSource.querySelector(".verfugbar-filter-label")?.value ||
      "Verfügbar";
    const selected = `${title}: ${label.textContent.trim()}`;
    if (text.textContent !== selected) text.textContent = selected;
  }

  function setDropdownOpen(dropdown, open) {
    dropdown.classList.toggle("open", open);
    dropdown
      .querySelector(".verfugbar-dropdown-toggle")
      ?.setAttribute("aria-expanded", String(open));
  }

  function replaceUrl(url) {
    history.replaceState(history.state || {}, "", url.toString());
    updateHeadPaginationLinks(url.toString());
  }

  function addStoreHiddenInput(form, value, name = storeFilterName) {
    const input = document.createElement("input");
    Object.assign(input, { type: "hidden", name, value });
    form.appendChild(input);
    return input;
  }

  // Die ID bleibt während eines Section-Austauschs bekannt, auch ohne Dropdown.
  let postversandValue = null;
  const postversandValueOf = () => {
    const input = Array.from(
      document.querySelectorAll(storeInputSelector),
    ).find(isPostversandInput);
    if (input) postversandValue = input.value;
    return postversandValue;
  };

  function initializeStoreOptions() {
    postversandValueOf();
    document.querySelectorAll("facet-filters-form form").forEach((form) => {
      const inputs = Array.from(
        form.querySelectorAll(`${storeInputSelector}[type="checkbox"]`),
      );
      const hasStore = inputs.some(
        (input) => input.checked && !isPostversandInput(input),
      );
      inputs.filter(isPostversandInput).forEach((input) => {
        input.disabled = false;
        input.labels?.[0]?.classList.remove("disabled");
        input.checked = !hasStore;
      });
    });
  }

  function removeStoreHiddenInputs() {
    document
      .querySelectorAll(
        `facet-filters-form ${storeInputSelector}[type="hidden"]`,
      )
      .forEach((input) => input.remove());
  }

  // Die Sidebar und der mobile Drawer verwenden native Checkboxen. Ihr Input-
  // Event reicht für die normale Facetten-Anfrage; Postversand löscht nur Filialen.
  document.addEventListener(
    "input",
    (event) => {
      const input = event.target;
      if (input.name !== storeFilterName || input.type !== "checkbox") return;
      const form = input.closest("form");
      if (!form) return;
      shouldAutoApplyPostversand = false;
      removeStoreHiddenInputs();
      const selected = isPostversandInput(input)
        ? []
        : Array.from(form.querySelectorAll(`${storeInputSelector}:checked`))
            .filter((option) => !isPostversandInput(option))
            .map((option) => option.value);
      document.querySelectorAll(storeInputSelector).forEach((option) => {
        option.checked = isPostversandInput(option)
          ? selected.length === 0
          : selected.includes(option.value);
      });
      document.querySelectorAll(".verfugbar-dropdown").forEach((dropdown) => {
        setSelectedText(
          dropdown,
          dropdown.querySelector(`${dropdownInputSelector}:checked`),
        );
      });
      // Erst facets.js schreibt den neuen Verlaufseintrag. replaceState hier
      // würde den vorherigen Eintrag überschreiben: Zurück zeigt dann ein
      // anderes Grid als die URL, und Neuladen ändert die Ergebnisse erneut.
    },
    true,
  );

  // Auch vorselektierte Radios und alte Hidden-Inputs dürfen Postversand nicht
  // an Shopify senden. Physische Filialwerte bleiben unverändert.
  function stripPostversand(params) {
    const value = postversandValueOf();
    if (!value || !params.getAll(storeFilterName).includes(value)) return false;
    const stores = params
      .getAll(storeFilterName)
      .filter((store) => store !== value);
    params.delete(storeFilterName);
    stores.forEach((store) => params.append(storeFilterName, store));
    return true;
  }

  document.addEventListener("formdata", (event) => {
    if (event.target.matches("facet-filters-form form")) {
      stripPostversand(event.formData);
    }
  });

  function normalizePostversandUrl() {
    const url = new URL(window.location.href);
    if (!stripPostversand(url.searchParams)) return false;
    // Ein alter Link hat bereits serverseitig gefiltert: auch das Grid neu laden.
    window.location.replace(url.toString());
    return true;
  }

  // Alte Postversand-Links durch eine ungefilterte Seite ersetzen. Bei Events
  // direkt auf window laufen früher registrierte Listener trotzdem zuerst;
  // stopImmediatePropagation verhindert nur die nachfolgenden Listener.
  window.addEventListener(
    "popstate",
    (event) => {
      if (normalizePostversandUrl()) event.stopImmediatePropagation();
    },
    true,
  );

  let shouldAutoApplyPostversand = false;
  let isApplyingAvailabilityFilter = false;

  function updateHeadPaginationLinks(currentUrl) {
    if (!currentUrl) return;

    try {
      ["next", "prev"].forEach((rel) => {
        const link = document.querySelector(`link[rel="${rel}"]`);
        if (!link) return;

        const existing = new URL(link.href, window.location.origin);
        const page = existing.searchParams.get("page");

        const updated = new URL(currentUrl, window.location.origin);
        updated.searchParams.delete("page");
        if (page) updated.searchParams.set("page", page);

        link.setAttribute("href", updated.toString());
      });
    } catch (error) {
      console.error("Error updating head pagination links:", error);
    }
  }

  const _origPushState = history.pushState.bind(history);
  history.pushState = function (state, title, url) {
    try {
      if (url && String(url).includes("filter.v.availability")) {
        const urlObj = new URL(url, window.location.origin);
        const values = urlObj.searchParams.getAll("filter.v.availability");
        if (values.length > 1) {
          urlObj.searchParams.delete("filter.v.availability");
          urlObj.searchParams.append("filter.v.availability", values[0]);
          url = urlObj.toString();
        }
      }
      updateHeadPaginationLinks(url);
    } catch (error) {
      console.error("Error in pushState override:", error);
    }
    return _origPushState(state, title, url);
  };

  function removeDuplicateUrlParams() {
    try {
      const currentUrl = window.location.href;
      const urlObj = new URL(currentUrl);
      const searchString = urlObj.search;

      if (!searchString || searchString.length <= 1) {
        return;
      }

      const paramPairs = searchString.substring(1).split("&");
      const seen = new Set();
      const uniquePairs = [];

      for (const pair of paramPairs) {
        if (pair && !seen.has(pair)) {
          uniquePairs.push(pair);
          seen.add(pair);
        }
      }

      if (uniquePairs.length < paramPairs.length) {
        const newSearch =
          uniquePairs.length > 0 ? "?" + uniquePairs.join("&") : "";
        const newUrl = `${urlObj.pathname}${newSearch}${urlObj.hash}`;

        if (newUrl !== currentUrl) {
          history.replaceState(history.state || {}, "", newUrl);
          updateHeadPaginationLinks(newUrl);
        }
      }
    } catch (error) {
      console.error("Error removing duplicate URL params:", error);
    }
  }

  function fixVerfugbarUrlParam() {
    try {
      const currentUrl = new URL(window.location.href);
      if (stripPostversand(currentUrl.searchParams)) {
        replaceUrl(currentUrl);
      }
    } catch (error) {
      console.error("Error fixing verfugbar URL param:", error);
    }
  }

  const storeNameCollator = new Intl.Collator("de", {
    sensitivity: "base",
    numeric: true,
  });

  // Shopify appends new stores to the end of the filter values; sort by name, Postversand first, and no-op when already ordered to avoid retriggering the observers.
  function sortVerfugbarDropdownOptions() {
    try {
      document.querySelectorAll(".verfugbar-dropdown-menu").forEach((menu) => {
        const items = Array.from(
          menu.querySelectorAll(".verfugbar-dropdown-item"),
        );
        if (items.length < 2) return;

        const container = items[0].parentElement;
        const siblings = items.filter(
          (item) => item.parentElement === container,
        );
        if (siblings.length < 2) return;

        const labelOf = (item) => {
          const label = item.querySelector(".verfugbar-option-text");
          return label ? label.textContent.trim() : "";
        };
        const isPostversand = (item) => {
          const input = item.querySelector(".verfugbar-filter-checkbox");
          return isPostversandInput(input);
        };

        const sorted = siblings.slice().sort((a, b) => {
          if (isPostversand(a) !== isPostversand(b)) {
            return isPostversand(a) ? -1 : 1;
          }
          return storeNameCollator.compare(labelOf(a), labelOf(b));
        });

        if (sorted.every((item, index) => item === siblings[index])) return;

        sorted.forEach((item) => container.appendChild(item));
      });
    } catch (error) {
      console.error("Error sorting store filter options:", error);
    }
  }

  function selectPostversand(dropdown, enabledOnly = false) {
    const inputs = Array.from(dropdown.querySelectorAll(dropdownInputSelector));
    const selected = inputs.find(
      (input) => isPostversandInput(input) && (!enabledOnly || !input.disabled),
    );
    if (!selected) return;
    inputs.forEach((input) => {
      input.checked = input === selected;
    });
    setSelectedText(dropdown, selected);
  }

  function resetMobileDropdownToFirst() {
    const dropdown = Array.from(
      document.querySelectorAll(".verfugbar-dropdown"),
    ).find(isMobileDropdown);
    if (dropdown) selectPostversand(dropdown);
  }

  function preselectPostversandInUI() {
    removeStoreHiddenInputs();
    // This global pass intentionally also checks disabled Postversand inputs.
    document.querySelectorAll(storeInputSelector).forEach((input) => {
      input.checked = isPostversandInput(input);
    });
    document.querySelectorAll(".verfugbar-dropdown").forEach((dropdown) => {
      selectPostversand(dropdown, true);
    });
  }

  function availabilityInputs(form) {
    return form.querySelectorAll(
      'input[name="filter.v.availability"][type="hidden"], ' +
        `${inStockAvailabilitySelector}:checked`,
    );
  }

  function removeAutoAvailabilityInputs(form) {
    form
      .querySelectorAll(
        'input[name="filter.v.availability"][type="hidden"][data-verfugbar-auto="true"]',
      )
      .forEach((input) => input.remove());
  }

  // triggerName ist der Name der Facette, die den Aufruf ausgelöst hat. Ohne einen
  // Namen aus AVAILABILITY_COUPLED_FILTERS wird nichts gesetzt (default-deny).
  function ensureAvailabilityFilter(targetForm = null, triggerName = null) {
    if (!needsAvailabilityFilter(triggerName) || isApplyingAvailabilityFilter)
      return false;
    try {
      isApplyingAvailabilityFilter = true;
      if (
        new URL(window.location.href).searchParams.has("filter.v.availability")
      )
        return false;
      targetForm = targetForm ||
        document.getElementById("FacetFiltersFormMobile") ||
        document.getElementById("FacetFiltersForm");
      if (
        !targetForm ||
        availabilityInputs(targetForm).length ||
        !hasInStockProducts()
      )
        return false;
      document
        .querySelectorAll(inStockAvailabilitySelector)
        .forEach((checkbox) => {
          if (!checkbox.disabled) checkbox.checked = true;
        });
      return true;
    } catch (error) {
      console.error("Error ensuring availability filter:", error);
      return false;
    } finally {
      isApplyingAvailabilityFilter = false;
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    if (normalizePostversandUrl()) return;
    let isInitializing = false;

    const containsStoreInput = (node) =>
      node.nodeType === 1 &&
      (node.matches(dropdownInputSelector) ||
        node.querySelector(dropdownInputSelector));
    const removedStoreInputs = (mutation) =>
      Array.from(mutation.removedNodes).some(containsStoreInput);
    const inputRemovalObserver = new MutationObserver((mutations) => {
      if (globalPreservedInputs && mutations.some(removedStoreInputs)) {
        setTimeout(() => restoreVerfugbarInputs(globalPreservedInputs), 50);
      }
    });

    const observeVerfugbarDropdowns = () => {
      document.querySelectorAll(".verfugbar-dropdown-menu").forEach((menu) => {
        inputRemovalObserver.observe(menu, {
          childList: true,
          subtree: true,
        });
      });
    };

    observeVerfugbarDropdowns();

    const dropdownObserver = new MutationObserver(function () {
      observeVerfugbarDropdowns();
    });
    dropdownObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    const boundControls = new WeakSet();

    function initializeVerfugbarDropdowns(forceReinit = false) {
      if (isInitializing) return;
      isInitializing = true;
      try {
        initializeStoreOptions();
        sortVerfugbarDropdownOptions();
        const hasStoreFilter = new URL(window.location.href).searchParams.has(
          storeFilterName,
        );
        document.querySelectorAll(".verfugbar-dropdown").forEach((dropdown) => {
          const toggle = dropdown.querySelector(".verfugbar-dropdown-toggle");
          const menu = dropdown.querySelector(".verfugbar-dropdown-menu");
          const inputs = Array.from(
            dropdown.querySelectorAll(dropdownInputSelector),
          );
          if (!toggle || !menu || !inputs.length) return;

          // Rebinding replaced controls must not reset an initialized selection.
          if (
            (forceReinit || dropdown.dataset.initialized !== "true") &&
            !hasStoreFilter &&
            !inputs.some((input) => input.checked)
          ) {
            selectPostversand(dropdown);
          }
          if (!boundControls.has(toggle)) {
            boundControls.add(toggle);
            toggle.addEventListener("click", (event) => {
              event.preventDefault();
              event.stopPropagation();
              if (!dropdown.querySelector(".verfugbar-dropdown-menu")) return;
              const open = !dropdown.classList.contains("open");
              document
                .querySelectorAll(".verfugbar-dropdown.open")
                .forEach((other) => {
                  if (other !== dropdown) setDropdownOpen(other, false);
                });
              document
                .querySelectorAll(".nice-select.open")
                .forEach((select) => {
                  select.classList.remove("open");
                });
              setDropdownOpen(dropdown, open);
            });
          }
          inputs.forEach((input) => {
            if (boundControls.has(input)) return;
            boundControls.add(input);
            input.addEventListener("change", onStoreChange);
          });
          dropdown.dataset.initialized = "true";
        });
      } finally {
        isInitializing = false;
      }
    }

    // One bubble listener, resolving current controls after section replacement.
    document.addEventListener("click", (event) => {
      document
        .querySelectorAll(".verfugbar-dropdown.open")
        .forEach((dropdown) => {
          if (!dropdown.contains(event.target))
            setDropdownOpen(dropdown, false);
        });
    });

    function onStoreChange() {
      const dropdown = this.closest(".verfugbar-dropdown");
      if (!this.checked || !dropdown) return;
      shouldAutoApplyPostversand = false;
      document
        .querySelectorAll(`input[name="${this.name}"]`)
        .forEach((input) => {
          if (input !== this)
            input.checked =
              input.type === "checkbox" && input.value === this.value;
        });
      document.querySelectorAll(".verfugbar-dropdown").forEach((other) => {
        setSelectedText(other, this, dropdown);
      });
      setDropdownOpen(dropdown, false);

      const availabilitySelector =
        'custom-accordion[id*="filter.v.availability"] details';
      const availabilityDetails = document.querySelector(availabilitySelector);
      const wasAvailabilityOpen =
        availabilityDetails?.hasAttribute("open") || false;
      const isMobile = this.dataset.isMobile === "true";
      const targetForm = isMobile
        ? document.getElementById("FacetFiltersFormMobile")
        : document.getElementById("FacetFiltersForm") ||
          document.getElementById("FacetSortForm");
      if (!targetForm) {
        console.error("No target form found!");
        return;
      }
      document.querySelectorAll("facet-filters-form form").forEach((form) => {
        hiddenStoreInputs(form, this.name).forEach((input) => input.remove());
      });

      if (isPostversandInput(this)) {
        preselectPostversandInUI();
        globalPreservedInputs = preserveVerfugbarInputs();
        targetForm.dispatchEvent(new Event("input", { bubbles: true }));
        return;
      }
      try {
        addStoreHiddenInput(targetForm, this.value, this.name);
      } catch (error) {
        console.error("Error adding verfugbar filter:", error);
        return;
      }
      globalPreservedInputs = preserveVerfugbarInputs();

      const dispatchInput = (target) =>
        target?.dispatchEvent(
          new Event("input", { bubbles: true, cancelable: true }),
        );
      const verifyAndTrigger = () => {
        if (!this.checked) return;
        const inputs = Array.from(hiddenStoreInputs(targetForm, this.name));
        inputs.forEach((input) => {
          if (input.value !== this.value) input.remove();
        });
        const currentInput =
          inputs.find((input) => input.value === this.value) ||
          addStoreHiddenInput(targetForm, this.value, this.name);
        dispatchInput(currentInput);
        dispatchInput(targetForm);
        if (isMobile) {
          dispatchInput(
            targetForm.querySelector('input:not([type="hidden"])') ||
              targetForm.querySelector('input[type="checkbox"]') ||
              targetForm.querySelector('input[type="radio"]'),
          );
        }
      };
      // Keep the legacy retry timing around Ignite's debounced form submission.
      setTimeout(verifyAndTrigger, 10);
      setTimeout(verifyAndTrigger, 100);
      [300, 1000].forEach((delay) =>
        setTimeout(() => {
          fixVerfugbarUrlParam();
          removeDuplicateUrlParams();
        }, delay),
      );

      // Only restore presentation; never replay old availability checkbox values.
      if (availabilityDetails) {
        setTimeout(() => {
          const details = document.querySelector(availabilitySelector);
          if (details) details.toggleAttribute("open", wasAvailabilityOpen);
          else
            console.warn(
              "Could not find availability filter details to restore",
            );
        }, 100);
      }
    }

    initializeVerfugbarDropdowns();

    const addedControlSelector = `.verfugbar-dropdown, .verfugbar-dropdown-toggle, ${dropdownInputSelector}`;
    const observer = new MutationObserver((mutations) => {
      const needsInitialization = mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some(
          (node) =>
            node.nodeType === 1 &&
            (node.matches(addedControlSelector) ||
              node.querySelector(addedControlSelector)),
        ),
      );
      if (needsInitialization) {
        requestAnimationFrame(() =>
          setTimeout(initializeVerfugbarDropdowns, 100),
        );
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    function preserveVerfugbarInputs() {
      return Array.from(
        document.querySelectorAll(".verfugbar-dropdown-item"),
      ).flatMap((item) => {
        const input = item.querySelector(dropdownInputSelector);
        const label = item.querySelector("label");
        if (!input || !label) return [];
        return [
          {
            input: input.cloneNode(true),
            labelFor: label.getAttribute("for"),
            labelText: label
              .querySelector(".verfugbar-option-text")
              ?.textContent.trim(),
          },
        ];
      });
    }

    function restoreVerfugbarInputs(preservedInputs) {
      if (!preservedInputs?.length) return;
      document.querySelectorAll(".verfugbar-dropdown-item").forEach((item) => {
        if (item.querySelector(dropdownInputSelector)) return;
        const label = item.querySelector("label");
        const labelFor = label?.getAttribute("for");
        const labelText = label
          ?.querySelector(".verfugbar-option-text")
          ?.textContent.trim();
        if (!labelFor || !labelText) return;
        const preserved =
          preservedInputs.find((entry) => entry.labelFor === labelFor) ||
          preservedInputs.find((entry) => entry.labelText === labelText);
        if (!preserved) return;
        const input = preserved.input.cloneNode(true);
        input.id = labelFor;
        item.insertBefore(input, label);
      });
      setTimeout(() => initializeVerfugbarDropdowns(true), 100);
    }

    let globalPreservedInputs = null;

    function applyAvailabilitySelection(form, input, clearOrphans = false) {
      if (!isFilterForm(form)) return;
      if (clearOrphans) {
        const otherHidden = Array.from(
          form.querySelectorAll('input[name^="filter."][type="hidden"]'),
        ).some((option) => option.name !== "filter.v.availability");
        const otherSelected = Array.from(
          form.querySelectorAll('input[name^="filter."]'),
        ).some(
          (option) =>
            option.name !== "filter.v.availability" &&
            (option.checked || option.type === "radio"),
        );
        if (!otherHidden && !otherSelected) {
          availabilityInputs(form).forEach((option) => {
            if (option.type === "hidden") option.remove();
            else option.checked = false;
          });
        }
      }
      ensureAvailabilityFilter(form, input.name);
    }

    function recoverAfterFilterUpdate(checkAutoApply = false) {
      restoreVerfugbarInputs(globalPreservedInputs);
      initializeVerfugbarDropdowns(true);
      removeDuplicateUrlParams();
      fixVerfugbarUrlParam();
      if (
        !new URL(window.location.href).searchParams.has(storeFilterName) &&
        (!checkAutoApply || !shouldAutoApplyPostversand)
      ) {
        resetMobileDropdownToFirst();
      }
    }

    document.addEventListener(
      "click",
      (event) => {
        const input = event.target.closest?.('input[name^="filter."]');
        const form = input?.closest("form");
        if (
          !input ||
          !isFacetForm(form) ||
          input.matches(dropdownInputSelector)
        )
          return;
        if (input.name === "filter.v.availability") {
          if (isFilterForm(form) && input.value === "0" && input.checked)
            removeAutoAvailabilityInputs(form);
          return;
        }
        if (input.checked || input.type === "radio")
          applyAvailabilitySelection(form, input, true);
      },
      true,
    );

    document.addEventListener(
      "input",
      (event) => {
        const input = event.target;
        const form = input.closest("form");
        if (
          !isFacetForm(form) ||
          input.matches(dropdownInputSelector) ||
          input.dataset.verfugbarAuto === "true"
        )
          return;
        if (isFilterForm(form) && input.name === "filter.v.availability") {
          if (
            (input.value === "0" && input.checked) ||
            (input.type === "checkbox" && !input.checked)
          ) {
            removeAutoAvailabilityInputs(form);
          }
          return;
        }
        if (
          input.name?.startsWith("filter.") &&
          input.name !== "filter.v.availability" &&
          ((input.type === "checkbox" && input.checked) ||
            input.type === "radio")
        ) {
          applyAvailabilitySelection(form, input, true);
        }
        if (shouldAutoApplyPostversand) {
          preselectPostversandInUI();
          shouldAutoApplyPostversand = false;
        }
        globalPreservedInputs = preserveVerfugbarInputs();
        setTimeout(() => recoverAfterFilterUpdate(true), 1000);
      },
      true,
    );

    document.addEventListener("submit", (event) => {
      if (!isFacetForm(event.target)) return;
      globalPreservedInputs = preserveVerfugbarInputs();
      setTimeout(recoverAfterFilterUpdate, 500);
    });

    const facetsObserver = new MutationObserver((mutations) => {
      const relevant = mutations.filter((mutation) =>
        mutation.target.closest?.(
          '.facets, [id*="facets"], .collection-filters',
        ),
      );
      if (!relevant.length) return;
      const shouldRestoreInputs = relevant.some(removedStoreInputs);
      setTimeout(() => {
        refreshDropdownOptions();
        if (shouldRestoreInputs) {
          // If a sibling dropdown still has controls, use those as the fallback.
          restoreVerfugbarInputs(preserveVerfugbarInputs());
        }
      }, 500);
    });

    const mainContent = document.querySelector("main") || document.body;
    facetsObserver.observe(mainContent, {
      childList: true,
      subtree: true,
    });

    function cleanupVerfugbarDuplicates(triggeringForm) {
      const value =
        new URL(window.location.href).searchParams.get(storeFilterName) ||
        document.querySelector(`${dropdownInputSelector}:checked`)?.value;
      if (!value || value === postversandValueOf()) return;
      const hidden = document.querySelectorAll(
        `facet-filters-form ${storeInputSelector}[type="hidden"]`,
      );
      if (!hidden.length) return;
      hidden.forEach((input) => input.remove());
      const targetForm =
        triggeringForm?.id === "FacetFiltersFormMobile"
          ? triggeringForm
          : document.getElementById("FacetFiltersForm") || triggeringForm;
      if (targetForm) addStoreHiddenInput(targetForm, value);
    }

    const isAvailabilityCheckbox = (input) =>
      input.name === "filter.v.availability" && input.type === "checkbox";

    document.addEventListener(
      "change",
      (event) => {
        const input = event.target;
        const form = input.closest("form");
        if (!isFacetForm(form)) return;
        if (
          input.name?.startsWith("filter.") &&
          input.name !== "filter.v.availability" &&
          ((input.type === "checkbox" && input.checked) ||
            input.type === "radio")
        ) {
          // Unlike click/input, change-only events do not clear orphan availability.
          applyAvailabilitySelection(form, input);
        }
        if (isAvailabilityCheckbox(input)) cleanupVerfugbarDuplicates(form);
      },
      true,
    );

    document.addEventListener(
      "input",
      (event) => {
        const form = event.target.closest("form");
        if (isFacetForm(form) && isAvailabilityCheckbox(event.target))
          cleanupVerfugbarDuplicates(form);
      },
      true,
    );

    window.addEventListener("popstate", function () {
      setTimeout(() => {
        initializeVerfugbarDropdowns(true);

        removeDuplicateUrlParams();

        fixVerfugbarUrlParam();
      }, 500);
    });

    function refreshDropdownOptions() {
      initializeStoreOptions();
      sortVerfugbarDropdownOptions();
      const desktop = document
        .querySelector('.verfugbar-dropdown [data-is-mobile="false"]')
        ?.closest(".verfugbar-dropdown");
      const desktopInputs = Array.from(
        desktop?.querySelectorAll(dropdownInputSelector) || [],
      );
      document.querySelectorAll(".verfugbar-dropdown").forEach((dropdown) => {
        const isMobile = isMobileDropdown(dropdown);
        dropdown.querySelectorAll(dropdownInputSelector).forEach((input) => {
          const label = input
            .closest(".verfugbar-dropdown-item")
            ?.querySelector(".verfugbar-dropdown-label");
          if (!label) return;
          // Desktop reflects Liquid; mobile mirrors desktop (or enables if absent).
          if (isMobile)
            input.disabled = Boolean(
              desktopInputs.find((other) => other.value === input.value)
                ?.disabled,
            );
          label.classList.toggle("disabled", input.disabled);
        });
      });
    }

    document.addEventListener(
      "click",
      (event) => {
        const facetRemove = event.target.closest("facet-remove");
        if (!facetRemove) return;
        const link = facetRemove.querySelector("a");
        const span = link?.querySelector("span");
        const isClearAll =
          Boolean(link) &&
          (facetRemove.matches(
            ".active-facets__button-wrapper, .mobile-facets__clear-wrapper",
          ) ||
            link.matches(
              ".active-facets__button-remove, .mobile-facets__clear",
            ));
        if (isClearAll) {
          shouldAutoApplyPostversand = true;
          setTimeout(() => {
            if (shouldAutoApplyPostversand) preselectPostversandInUI();
          }, 200);
        }
        // The legacy no-span clear-all branch has no URL-deduplication tail.
        if (span || !isClearAll) {
          const text = span?.textContent.trim() || "";
          const isStoreFacet = ["Verfügbar:", "Available:", "Disponible:"].some(
            (prefix) => text.startsWith(prefix),
          );
          requestAnimationFrame(() =>
            setTimeout(() => {
              removeDuplicateUrlParams();
              if (isStoreFacet) resetMobileDropdownToFirst();
            }, 150),
          );
        }
      },
      true,
    );

    const hideFacetsObserver = new MutationObserver((mutations) => {
      if (
        mutations.some((mutation) =>
          mutation.target.closest?.(
            '.active-facets, [id*="facets"], .collection-filters',
          ),
        )
      ) {
        setTimeout(() => {
          removeDuplicateUrlParams();
          if (!new URL(window.location.href).searchParams.has(storeFilterName))
            resetMobileDropdownToFirst();
        }, 50);
      }
    });

    hideFacetsObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    removeDuplicateUrlParams();

    window.initializeVerfugbarDropdowns = initializeVerfugbarDropdowns;
    window.refreshDropdownOptions = refreshDropdownOptions;
  });
}
